import { FC } from "react"
import { Box, Card, Theme, ThemeProvider, Typography, useTheme, CssBaseline as MuiCssBaseline } from "@mui/material"
import { Trans } from "@lingui/macro"
import Brand from "app/EgretLayout/SharedCompoents/Brand"
import { createTheme } from "@mui/material/styles"
import SelectLanguageDropdown from "../topbar/SelectLanguageDropdown"
import { HelpButton } from "../topbar/HelpButton"
import { HELP_CASE_TYPES } from "app/services/sfAuth/sfData/sfCase"

export const getFirstLoginFlowTheme = (existingTheme: Theme) => {
  return createTheme({
    ...existingTheme,
    components: {
      ...existingTheme?.components,
      MuiCssBaseline: {
        styleOverrides: {
          '#root': {
            overflow: 'auto !important'
          }
        }
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            display: 'block',
            color: existingTheme.palette.primary.main,
            fontWeight: 'bold',
            fontSize: '20px',
            marginBottom: '24px',
            '&.Mui-error': {
              color: existingTheme.palette.primary.main
            }
          }
        }
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            height: '38px',
            color: existingTheme.palette.primary.main,
            '& .MuiInputBase-input': {
              paddingTop: 0,
              paddingBottom: 0,
            },
            '& input': {
              padding: '9.5px 14px'
            }
          }
        }
      },
      MuiCard: {
        styleOverrides: {
          root: {
            '& img': {
              height: '48px',
              marginRight: '16px',
            },
            '& .brand-area': {
              display: 'flex',
              justifyContent: 'center !important',
              alignItems: 'center',
            },
            '& .brand p': {
              fontWeight: 600,
              fontSize: 26,
            }
          }
        }
      },
    }
  })
}

const FirstLoginFlowLayout: FC = ({children}) => {

  const theme = useTheme()
  const _theme = getFirstLoginFlowTheme(theme)

  return (<ThemeProvider theme={_theme}>
    <MuiCssBaseline />
    <Card 
      className='flex-center'
      sx={{
        width: '100%',
        minHeight: '100vh',
        backgroundColor: '#F9F7F7',
        position: 'relative',
        pb: '100px'
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '58px',
          right: '65px',
        }}
      >
        <HelpButton caseType={HELP_CASE_TYPES.HELP} />
      </Box>
      <Box 
        sx={{
          marginTop: '188px',
          marginBottom: '38px',
        }}
      >
        <Brand/>
      </Box>
      <Box
        sx={{
          padding: '75px 90px 48px 90px',
          backgroundColor: 'white',
          margin: 'auto',
          maxWidth: '800px',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '16px',
            right: '16px',
          }}
        >
          <SelectLanguageDropdown />
        </Box>
        {children}
      </Box>
    </Card>
  </ThemeProvider>)
}

export default FirstLoginFlowLayout